"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Skeleton = require("../Skeleton");
var _ImageModule = _interopRequireDefault(require("./Image.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// named Img here to avoid conflict with the HTMLImageElement in useEffect
var Img = _ref => {
  var className = _ref.className,
    _ref$objectFit = _ref.objectFit,
    objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,
    alt = _ref.alt,
    src = _ref.src,
    onLoad = _ref.onLoad,
    onError = _ref.onError;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    loadedImage = _useState2[0],
    setLoadedImage = _useState2[1];
  (0, _react.useEffect)(() => {
    setLoadedImage(undefined);
    if (src && Boolean(new URL(src))) {
      var image = new Image();
      image.src = src;
      // if image is cached, set isCached so we can skip animations
      if (image.complete) {
        setLoadedImage({
          isCached: true,
          src
        });
      } else {
        // else wait until load is complete to set state
        image.onload = () => {
          setLoadedImage({
            isCached: false,
            src
          });
        };
        image.onerror = () => {
          onError === null || onError === void 0 || onError();
        };
      }
    }
  }, [src, onError]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ImageModule.default.Container, className),
    "data-status": loadedImage !== null && loadedImage !== void 0 && loadedImage.src ? 'loaded' : 'loading',
    "data-is-cached": loadedImage !== null && loadedImage !== void 0 && loadedImage.isCached ? '' : undefined
  }, /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": 'zui-image-img',
    className: _ImageModule.default.Image,
    style: {
      objectFit
    },
    src: loadedImage === null || loadedImage === void 0 ? void 0 : loadedImage.src,
    alt: alt,
    onLoad: onLoad,
    onError: onError
  }), /*#__PURE__*/_react.default.createElement(_Skeleton.Skeleton, {
    className: _ImageModule.default.Skeleton,
    width: '100%',
    height: '100%'
  }));
};
exports.Image = Img;
//# sourceMappingURL=Image.js.map